import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" {...this.props}><path className="cls-1" d="M16.47 33.13a16.575 16.575 0 1 1 16.47-16.57 16.538 16.538 0 0 1-16.47 16.57zm0-31.75a15.18 15.18 0 1 0 15.09 15.18A15.144 15.144 0 0 0 16.47 1.38zm18.51 35.61l-8.61-9.48 1.02-.94L36 36.04z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/widget/components/empty-search-results/images/search.svg